,<template>
  <div>
    <b-tabs active-nav-item-class="font-weight-bold text-light bg-info">
      <b-tab
        :title="$t('Бемор')"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <Bayonnoma
            v-if="history_type == 'default'"
            :statsionar_text="reg_statsionar.statsionar_text"
            :modalIdCom="modalIdCom"
            @changeHistoryId="changeHistoryId"
            :history_id="history_id"
            @statsionar_text_change="statsionar_text_change"
          />
          <BayonnomaT
            v-else
            :statsionar_text="reg_statsionar.statsionar_text"
            :modalIdCom="modalIdCom"
            @changeHistoryId="changeHistoryId"
            :history_id="history_id"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab>
      <b-tab
        v-if="history_type == 'default'"
        :title="$t('Текшириш')"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <StatDoctor
            :statsionar_text="reg_statsionar.text"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab>
      <b-tab
        :title="'Текширувлар хулосаси'"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <Xulosalar
            :statsionar_text="reg_statsionar.xulosa"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab>

      <b-tab
        :title="'Муолажалар'"
        @click="getRegDrug"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <Muolajalar
            :statsionar_text="reg_statsionar.xulosa"
            :registration_drug="registration_drug"
            :trDatas="trDatas"
            :days="days"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
            @tasdiqlash="tasdiqlash"
            @delete_drug="delete_drug"
          />
        </div>
      </b-tab>
      <b-tab
        :title="'Клиник ташхис'"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <KlinikTash
            :statsionar_text="reg_statsionar.asoslash"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab>
      <!-- <b-tab
        :title="'Операция олди эпикризи'"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <KlinikTash
            :statsionar_text="reg_statsionar.asoslash"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab> -->
      <b-tab
        :title="$t('Кундалик')"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <Kundalik
            :statsionar_text="reg_statsionar.kundalik"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab>
      <b-tab
        :title="'Виписка'"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <KasTarKoch
            :statsionar_text="reg_statsionar.vipiska"
            :modalIdCom="modalIdCom"
            @statsionar_text_change="statsionar_text_change"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import Bayonnoma from "./Bayonnoma.vue";
import BayonnomaT from "./BayonnomaT.vue";
import StatDoctor from "./StatDoctor.vue";
import moment from "moment";
import Kundalik from "./Kundalik.vue";
import Xulosalar from "./Xulosalar.vue";
import Muolajalar from "./Muolajalar.vue";
import KasTarKoch from "./KasTarKoch.vue";
import KlinikTash from "./KlinikTash.vue";
export default {
  props: [
    "reg_statsionar",
    "history_id",
    "modalIdCom",
    "registration_drug",
    "trDatas",
    "days",
    "history_type"
  ],
  components: {
    Bayonnoma,
    BayonnomaT,
    StatDoctor,
    Kundalik,
    Xulosalar,
    Muolajalar,
    KasTarKoch,
    KlinikTash
  },
  data() {
    return {};
  },
  filters: {
    DateFormat: date => {
      if (date) {
        return moment.unix(date).format("DD MM YYYY HH:mm:ss");
      } else {
        return "";
      }
    }
  },
  methods: {
    changeHistoryId(data) {
      this.$emit("changeHistoryId", data);
    },
    tasdiqlash(data) {
      this.$emit("tasdiqlash", data);
    },
    delete_drug(item, index) {
      this.$emit("delete_drug", item, index);
    },
    getRegDrug() {},
    statsionar_text_change(data, doc_type) {
      if (doc_type == "bayonnoma") {
        this.reg_statsionar.statsionar_text = data;
      } else if (doc_type == "tekshirish") {
        this.reg_statsionar.text = data;
      } else if (doc_type == "xulosalar") {
        this.reg_statsionar.xulosa = data;
      } else if (doc_type == "kundalik") {
        this.reg_statsionar.kundalik = data;
      } else if (doc_type == "asoslash") {
        this.reg_statsionar.asoslash = data;
      } else if (doc_type == "vipiska") {
        this.reg_statsionar.vipiska = data;
      }
    }
  }
};
</script>

<style></style>
